module.exports = __webpack_public_path__ + "img/NW08.119a08a6.jpg";